// src/services/barcodeApi.js
import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

/**
 * Génère un code-barres UNIQUE du type: PREFIX + numéro avec padding (digits).
 * Exemple: EK0000000123
 */
export async function generateUniqueBarcode({
  prefix = "EK",
  digits = 10,
} = {}) {
  const cleanPrefix = (prefix || "EK")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  const d = Math.max(1, Math.min(18, Number(digits) || 10));

  const code = await runTransaction(db, async (tx) => {
    // === LECTURES ===
    const counterRef = doc(db, "counters", cleanPrefix);
    const counterSnap = await tx.get(counterRef);
    const base = counterSnap.exists() ? Number(counterSnap.data().value) || 0 : 0;

    // On cherche le premier numéro libre
    let candidate = base + 1;
    let codeRef = doc(
      db,
      "barcodes",
      `${cleanPrefix}${String(candidate).padStart(d, "0")}`
    );
    let codeSnap = await tx.get(codeRef);

    let guard = 0;
    while (codeSnap.exists() && guard < 20) {
      candidate++;
      codeRef = doc(
        db,
        "barcodes",
        `${cleanPrefix}${String(candidate).padStart(d, "0")}`
      );
      codeSnap = await tx.get(codeRef);
      guard++;
    }
    if (guard >= 20) {
      throw new Error("Trop de collisions, réessaie.");
    }

    const codeStr = `${cleanPrefix}${String(candidate).padStart(d, "0")}`;

    // === ÉCRITURES APRÈS TOUTES LES LECTURES ===
    if (counterSnap.exists()) {
      tx.update(counterRef, {
        value: candidate,
        updatedAt: serverTimestamp(),
      });
    } else {
      tx.set(counterRef, {
        value: candidate,
        updatedAt: serverTimestamp(),
      });
    }

    tx.set(codeRef, {
      code: codeStr,
      prefix: cleanPrefix,
      number: candidate,
      digits: d,
      createdAt: serverTimestamp(),
    });

    return codeStr;
  });

  return code;
}
